<template>
  <b-row class="text-center" align-v="center" :class="userStore.borderClass">
    <b-col cols="*">
      <b-button :class="modalTheme" @click="clearSelectedPatients" type="button" size="sm" variant="primary-green" class="tasks-button no-wrap" style="margin-right: 10px">Clear Dash Task</b-button>
      <b-button :class="modalTheme" class="tasks-button no-wrap" variant="primary-green" :disabled="props.disabled" size="sm" v-b-toggle.dashTaskSidebar>{{
        context ? context.title : "Create DASH Task/Message"
      }}</b-button>
    </b-col>
    <!-- <b-col cols="1" class="d-flex justify-content-center"></b-col> -->
    <!-- <b-col class="d-flex justify-content-end"></b-col> -->
  </b-row>
  <b-sidebar
    no-header
    id="dashTaskSidebar"
    :width="userdashTaskSidebarWidth + '%'"
    ref="sideBar"
    title="Create Dash Task/Message"
    v-model="isDashTaskSidebarOpen"
    :sidebar-class="modalTheme"
    :body-class="modalTheme"
    :header-class="modalTheme"
    backdrop
    right
    shadow
  >
    <template #default="{ hide }">
      <div class="d-flex align-items-center px-3 py-2">
        <b-button :class="modalTheme" size="sm" @click="hide" style="margin-left: 0px">&times;</b-button>
        <h5 class="mr-auto"><strong class="mr-auto" style="margin-left: 160px">Create Dash Task/Message</strong></h5>
      </div>
      <!-- Sidebar content goes here -->

      <div style="background: transparent; padding: 3px; overflow: hidden" :class="modalTheme">
        <CreateNewTask class="form" :context="props.context" :records="props.records" @createNewTask="onSubmitCreateNewTask" />
      </div>
    </template>
  </b-sidebar>
  <!-- <b-button class="tasks-button no-wrap" @click="showModal = true" size="sm" :disabled="disabled" variant="primary">
			{{
			context ? context.title : 'Create Task'
			}}
		</b-button>

		<b-modal v-model="showModal" size="lg" :hide-footer="true" title="Create Task" header-bg-variant="primary" header-text-variant="primary-white" :no-close-on-backdrop="true">
	<CreateReassignOrNewTask
        v-if="context.canReassign"
        class="form"
        :context="context"
        :records="records"
        @submit-create-new-task="onSubmitCreateDashTask"
        @close-modal="showModal = false"
			/>
			<CreateNewTask class="form" :context="context" :records="records" @submit-create-new-task="onSubmitCreateDashTask" @close-modal="showModal = false" />
	</b-modal>-->
</template>

<script setup>
import { ref, onMounted, computed } from "vue";
// * STOREs
import { useStoreUser } from "@/stores/userStore";
const userStore = useStoreUser();

// * STOREs
import { useStoreWorkList } from "@/stores/workListsStore";
const workListStore = useStoreWorkList();

import { toast } from "vue3-toastify";

import CreateNewTask from "@/modules/Messaging/CreateNewTask.vue";
import { createNewTasks } from "@/api/discreteDataApi";

// & PROPS
const props = defineProps({
  records: {
    type: Array,
    required: false,
    default: () => [],
  },
  disabled: {
    type: Boolean,
    default: () => [],
  },
  context: {
    type: Object,
    Default: () => {},
  },
});

// * EMITTER
const emit = defineEmits(["clearWorkListRecords"]);

const modalTheme = computed(() => userStore.bModalTheme);
const devExTheme = computed(() => userStore.devExTheme);

const AreIdsShown = ref(true);
const isDashTaskSidebarOpen = ref(false);
const userdashTaskSidebarWidth = ref(35);

async function onSubmitCreateNewTask(payload) {
  ////// console.clear()()
  // console.log(' NewDashTask > onSubmitCreateNewTask')
  // console.log(payload)

  const response = await createNewTasks(payload);

  if (response.ok) {
    isDashTaskSidebarOpen.value = false;
    toast.success("Successfully Created Task");
    // // console.log(' response  ok ')
    // // console.log(' BOOL Switch : isDashTaskSidebarOpen ')
    // // console.log(this.isDashTaskSidebarOpen)

    //TODO  CLEAR FORM
    // this.$emit("clearWorkListRecords", payload);
    emit("clearWorkListRecords", payload);
  }

  //! Clear localStorage
  // // console.log('		LOCAL Stor')
  // // console.dir(localStorage)
  // // console.log('				onSubmitCreateNewTask   - 	CLEAR 		LOCAL Stor')
  localStorage.clear();
  // // console.dir(localStorage)
}

function clearSelectedPatients() {
  ////// console.clear()()
  // // console.log(' 		STORE workList Selected Patients')

  // this.$store.state['workLists'].taskRecords = []
  //this.$store.state['taskBuilder'].taskRecords = []
  // workListStore.taskRecords = this.$store.state['workLists'].taskRecords

  workListStore.taskRecords = [];
  workListStore.taskRecords = workListStore.taskRecords;

  // console.dir(workListStore.taskRecords)
}

onMounted(() => {
  // // console.clear()
  // console.log("onMounted() :      CREATE nEW DASH TASK SIDEBAR                          TO BUILD  >>>>>             >>>>");
  // toast.success("Successfully Created Task");
  // console.log('props : ')
  // console.log(props)
  // console.log(' prop   records ')
  // console.log(props.records)
  // console.log(' prop   disabled ')
  // console.log(props.disabled)
  // console.log(' prop   context ')
  // console.log(props.context)
});
</script>

<style scoped lang="scss">
.form {
  margin: 0 auto;
  width: 90%;
}

.btn-primary-green {
  color: #007bff;
  border: none;
  text-decoration: none;
  background-color: transparent;
}

.btn-primary-green:hover {
  background-color: #caeacd;
  color: #123486;
  border-radius: 0px 0px 0px 0px;
}

.btn-sm,
.btn-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  line-height: 1;
  border-radius: 0.2rem;
  background: #eef8ef;
}
</style>
